import PortalLayout from "src/layout/PortalLayout";
import Loadable from "src/components/Loadable";
import { lazy } from "react";

const EnhancedDashboard = Loadable(
  lazy(() =>
    import("src/app/panel/ADMIN_PORTAL/ValueDashboard/EnhancedDashboard")
  )
);

const SubAdminRoutes = () => {
  return {
    path: "portal/sub-admin",
    element: <PortalLayout />,
    children: [
      {
        path: "dashboard",
        element: <EnhancedDashboard />,
      },
    ].filter(Boolean),
  };
};

export default SubAdminRoutes;
